import {Pipe, PipeTransform} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

@Pipe({
  name: 'dynamicAppTitle',
  standalone: false
})
export class DynamicAppTitlePipe implements PipeTransform {
  transform(module: 'm1' | 'm2' | 'home' | 'landing-page'): string {
    switch (module) {
      case 'm1':
        return 'm2.sprint11.application.title.m1';
      case 'm2':
        return 'm2.sprint11.application.title.m2';
      case 'home':
        return 'm1-m2.sprint11.application.title.long';
      case 'landing-page':
      default:
        return 'landing-page.application.title';
    }
  }
}
